module.exports = __webpack_public_path__ + "src/assets/img/visual_blotched-pattern.1acef60d.jpg";